import Inicio from "@/views/Inicio.vue";

const inicio = {
  path: "/",
  name: "inicio",
  component: Inicio
};

export default inicio;
